import { Input } from 'antd';
import React, { Component } from 'react';
import { toTitleCase } from 'untils';
import {
  clearSessionStorage,
  openLoginPopup,
  regularCheck,
  setSessionStorage,
} from '../../untils/auth';
import country from '../../untils/country.json';
import SelectMenu from '../selectMenu';

export default class AddUserInfo extends Component {
  state = {
    firstName: '', // 用户名',
    email: '', // 邮箱
    ruleFirstName: true, // 检验用户名
    ruleEmail: true, // 检验邮箱
    rulePhone: true, // 检验手机号
    countrySelectShow: false, // 选择国家区号下拉框
    countryCodeList: country, // 国家区号
    phoneCode: 1,
    countryCode: 'US',
    phone: '', // 手机号
    sourceValue: '',
  };

  // 获取下拉菜单数据
  getSourceValue = (value) => {
    this.setState({
      sourceValue: value,
    });
  };

  // 模糊搜索国家区号
  filterCode = (e) => {
    let countryCodeList = country.filter((item) => {
      return (
        item.countryName.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1 ||
        item.phoneCode.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1
      );
    });
    this.setState({
      countryCodeList,
    });
  };

  // 选择国家区号
  chooseCode = (item) => {
    this.setState({
      countrySelectShow: false,
      countryCodeList: country,
      phoneCode: item.phoneCode,
      countryCode: item.iso2,
      country: item.countryName,
    });
  };

  // 获取表单赋值
  changeContent = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  to;
  // 鼠标失去光标
  blur = (e) => {
    const { name, value } = e.target;
    if (!value || !name) return;
    const checkRule = {
      firstName: 'userName',
      email: 'email',
      phone: 'numberPhone',
    };
    this.setState({
      [`rule${toTitleCase(name)}`]: regularCheck(checkRule[name], value),
    });
  };

  //关闭弹窗
  closeDialog = () => {
    this.props.closeDialogHandle();
    clearSessionStorage('chaData');
    clearSessionStorage('eptData');
  };

  // 提交
  handleSubmit = (e) => {
    e.preventDefault();
    let { firstName, email, phone, phoneCode, sourceValue } = this.state;

    // check phone if only phone is not empty
    const validPhone = phone ? regularCheck('numberPhone', phone) : true;
    const validEmail = regularCheck('email', email);
    const validName = regularCheck('registerName', firstName);

    this.setState({
      ruleFirstName: validName,
      ruleEmail: validEmail,
      rulePhone: validPhone,
    });

    if (validName && validEmail && validPhone) {
      let data = this.props.currentParams;
      data.name = firstName;
      data.email = email;
      data.phoneCode = phoneCode;
      if (phone) data.phone = phone;
      data.source = sourceValue;
      this.props.submitInquireAjax(data);
    }
  };

  // 去登录
  goLogin = () => {
    if (this.props.type === 'emptyLeg') {
      setSessionStorage('emptyLegDetails', this.props.history.location.pathname);
    } else {
      setSessionStorage('charterQuote', this.props.history.location.pathname);
    }
    this.props.closeDialogHandle();
    let body = document.body;
    body.style.overflow = 'hidden';
    openLoginPopup('open');
  };

  render() {
    let {
      firstName,
      email,
      ruleFirstName,
      ruleEmail,
      rulePhone,
      phoneCode,
      countryCode,
      countrySelectShow,
      countryCodeList,
      phone,
    } = this.state;
    let { type } = this.props;

    return (
      <div className="telephone_dialog">
        <div className="dialog_content add_info_content">
          <button onClick={this.closeDialog} className="close">
            <img
              src={require('../../assets/imgs/svg/coupons_close.svg').default}
              alt="close icon"
            />
          </button>

          <div className="request-form-title">
            <div className="public-title">
              <span>Complete your Request</span>
              <p>Tell us where to deliver your custom estimate!</p>
            </div>
          </div>

          <form className="info_form" onSubmit={this.handleSubmit} id="send-inquiry-form">
            <div className="or">
              <img className="or_img" src="/imgs/svg/form-tit.svg" alt="title icon" />
            </div>

            <ul className="info_content">
              <li>
                <div className="double">
                  <div className="input-text">
                    <input
                      name="firstName"
                      type="text"
                      className={!ruleFirstName ? 'error' : ''}
                      placeholder={`${type === 'coupons' ? 'Name' : 'Your Name'}`}
                      value={firstName}
                      onChange={this.changeContent}
                      onBlur={this.blur}
                    />
                    {firstName && (
                      <button
                        type="button"
                        className="operation-icon clear-icon"
                        onClick={() => this.setState({ firstName: '' })}
                      />
                    )}
                    <div className="public-icon name-icon" />
                  </div>
                </div>
                {!ruleFirstName && (
                  <div className="error-text">
                    <span>Please enter your name in English</span>
                  </div>
                )}
              </li>

              <li>
                <div className="input-text">
                  <input
                    type="email"
                    name="email"
                    className={!ruleEmail ? 'error' : ''}
                    placeholder={'Enter your email address'}
                    value={email}
                    onChange={this.changeContent}
                    onBlur={this.blur}
                  />
                  {email && (
                    <button
                      type="button"
                      className="operation-icon clear-icon"
                      onClick={() => this.setState({ email: '' })}
                    />
                  )}
                  <div className="public-icon email-icon" />
                </div>
                {!ruleEmail && (
                  <div className="error-text">
                    <span>Please enter a valid email address</span>
                  </div>
                )}
              </li>

              <li>
                <div className={`code ${!rulePhone ? 'error' : ''}`}>
                  <div onClick={() => this.setState({ countrySelectShow: true })}>
                    <img
                      src={`${
                        process.env.REACT_APP_ASSET_URL
                      }/country/${countryCode.toLowerCase()}.webp`}
                      alt="flag"
                      className="flag"
                    />
                    <img
                      src={require('../../assets/imgs/svg/black-down-sanjiao.svg').default}
                      alt="sanjiao icon"
                      className="sanjiao"
                    />
                    <span>+{phoneCode}</span>
                  </div>
                  <input
                    name="phone"
                    type="tel"
                    placeholder={'Mobile number (optional)'}
                    value={phone}
                    onChange={this.changeContent}
                    onBlur={this.blur}
                  />
                </div>
                {!rulePhone && (
                  <div className="error-text">
                    <span>Please enter a valid 6-11 digit phone</span>
                  </div>
                )}
                {countrySelectShow ? (
                  <>
                    <div className="country-code">
                      <Input placeholder="Search" onChange={(e) => this.filterCode(e)} />
                      <ul>
                        {countryCodeList.map((item, index) => {
                          return (
                            <li key={index} onClick={() => this.chooseCode(item)}>
                              <div>
                                <img
                                  src={`${
                                    process.env.REACT_APP_ASSET_URL
                                  }/country/${item.iso2.toLowerCase()}.webp`}
                                  alt="flag"
                                />
                                <span className="countryname">{item.countryName}</span>
                              </div>
                              <span>{item.phoneCode}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    <button
                      className="country-code-mask"
                      onClick={() =>
                        this.setState({
                          countrySelectShow: false,
                          countryCodeList: country,
                        })
                      }
                    ></button>
                  </>
                ) : null}
              </li>

              <li>
                <div style={{ textAlign: 'center' }}>
                  <SelectMenu getSourceValue={this.getSourceValue} />
                </div>
              </li>
            </ul>

            <button type="submit" className="bg-image submit_btn">
              Send Inquiry
            </button>
          </form>

          <div className="login">
            Already registered?{' '}
            <button type="button" onClick={this.goLogin}>
              Sign in
            </button>
          </div>

          <div className="contact">
            🔒 Your Privacy Is Our Priority
            <br /> Need Immediate Assistance? <br />
            📞 Call Us! <br />
            +1 800-213-5051
          </div>
        </div>
      </div>
    );
  }
}
